// extracted by mini-css-extract-plugin
module.exports = {"noticeSection":"_14744","noticeText":"_16753"};